// [2026-10-25] หน้าโหลดโลโก้เว็บ — ตอนกดปุ่มที่ต้องรอ API (เช่น เปิดหน้ารายการเกม / เข้าเกม / ล็อกอิน / ฝาก-ถอน)
//   - ผูกกับ axios-instance.js (interceptor) → ทุก request ที่ช้ากว่า SHOW_DELAY จะขึ้นโลโก้ เร็วกว่านั้นไม่ขึ้น (ไม่กระพริบ)
//   - request เบื้องหลัง (เช็คยอดเงิน, ตั้งค่า, แบนเนอร์ ...) ไม่ขึ้น → ดู EXCLUDE
//   - ไม่อยากให้ขึ้นเฉพาะครั้ง: instance.post(url, data, { noLoader: true })
//   - โลโก้: จำจาก /api/v1/mainsetting (tblsetting[0].imglogo) ไว้ใน localStorage ใช้ร่วมกับหน้าโหลดตอนเปิดเว็บ (public/index.html)

const SHOW_DELAY = 250;   // ms — API ตอบเร็วกว่านี้ไม่ต้องโชว์
const MAX_SHOW = 15000;   // ms — กันค้าง
const LS_LOGO = 'site_loader_logo';
// กดแล้วขึ้นทันที (ไม่รอ SHOW_DELAY): ล็อกอิน / สมัคร / เข้าเกม / เปิดรายการเกม / ฝาก-ถอน
const NOW = /\/api\/v1\/(userlogin|register|tablauncher|tablauncherlotto|tabgamelist|userwithdraw|getqrcode|deposittruewallet|createdepositexpect|resetpassword)\b/i;
const EXCLUDE = /\/api\/v1\/(mainsetting|checkpoint|cacheversion|getthemesv|popuplist|saveclick|saveclickaff|tabbannerlist|gettoprank|getpromotion|checkuseradvice|getcheckin|getwheelspin|gettrue|getcardminigame|rewardlist)\b/i;

let pending = 0;
let showTimer = null;
let maxTimer = null;
let holdUntil = 0;   // flashLoader: โชว์อย่างน้อยถึงเวลานี้

function el() {
  let box = document.getElementById('site-loader');
  if (box) return box;
  box = document.createElement('div');
  box.id = 'site-loader';
  box.innerHTML = '<div class="sl-inner"><img class="sl-logo" alt="" /><div class="sl-ring"></div></div>';
  document.body.appendChild(box);
  setLogo(readLogo());
  return box;
}
// [2026-11-04] เว็บที่ใช้โลโก้ไฟล์ในเว็บเอง (ไม่ได้ดึงจาก BO) ตั้ง window.SITE_LOGO ใน public/index.html -> ใช้ตัวนั้นเสมอ
function readLogo() {
  if (typeof window !== 'undefined' && window.SITE_LOGO) return window.SITE_LOGO;
  try { return localStorage.getItem(LS_LOGO) || ''; } catch (e) { return ''; }
}
function setLogo(url) {
  const box = document.getElementById('site-loader');
  if (!box) return;
  const img = box.querySelector('.sl-logo');
  if (!img) return;
  if (url) { if (img.getAttribute('src') !== url) img.setAttribute('src', url); img.style.display = ''; }
  else img.style.display = 'none';
}

export function showLoader() {
  const box = el();
  box.classList.add('show');
  clearTimeout(maxTimer);
  maxTimer = setTimeout(forceHide, MAX_SHOW);
}
export function hideLoader() {
  if (Date.now() < holdUntil || pending > 0) return; // ยังอยู่ในช่วงขั้นต่ำ / ยังรอ API
  const box = document.getElementById('site-loader');
  if (box) box.classList.remove('show');
  clearTimeout(maxTimer);
}
function forceHide() { pending = 0; holdUntil = 0; clearTimeout(showTimer); showTimer = null; hideLoader(); }

// กดปุ่มเปลี่ยนหน้า (หมวดเกม / รายการเกม) — บางหน้าใช้ cache ไม่ยิง API → ขึ้นโลโก้สั้น ๆ ให้รู้ว่ากดติด
//   ถ้ามี API ตามมา จะค้างจนกว่า API เสร็จ
export function flashLoader(ms = 450) {
  holdUntil = Math.max(holdUntil, Date.now() + ms);
  showLoader();
  setTimeout(hideLoader, ms + 20);
}

function begin(now) {
  pending++;
  if (now) { clearTimeout(showTimer); showTimer = null; showLoader(); return; }
  if (pending === 1 && !showTimer) showTimer = setTimeout(() => { showTimer = null; if (pending > 0) showLoader(); }, SHOW_DELAY);
}
function end() {
  pending = Math.max(0, pending - 1);
  if (pending === 0) { clearTimeout(showTimer); showTimer = null; hideLoader(); }
}

function rememberLogo(res) {
  if (typeof window !== 'undefined' && window.SITE_LOGO) return; // ใช้โลโก้ของเว็บเอง ไม่เอาจาก BO
  try {
    const url = res && res.config && res.config.url;
    if (!url || url.indexOf('mainsetting') < 0) return;
    const logo = res.data && res.data.tblsetting && res.data.tblsetting[0] && res.data.tblsetting[0].imglogo;
    if (logo && typeof logo === 'string') { localStorage.setItem(LS_LOGO, logo); setLogo(logo); }
  } catch (e) { /* ignore */ }
}

export function attachLoader(instance) {
  instance.interceptors.request.use((config) => {
    const skip = config.noLoader || EXCLUDE.test(String(config.url || ''));
    config.__sl = !skip;
    if (!skip) begin(config.loaderNow || NOW.test(String(config.url || '')));
    return config;
  }, (err) => Promise.reject(err));
  instance.interceptors.response.use((res) => {
    if (res.config && res.config.__sl) end();
    rememberLogo(res);
    return res;
  }, (err) => {
    if (err && err.config && err.config.__sl) end();
    return Promise.reject(err);
  });
}
